import React, { useEffect, useState } from 'react';
import './issue-categories.scss';
import BarChart from '../bar-chart/bar-chart';
import { observer } from 'mobx-react-lite';
import widgetsService from '../../../../services/widgets.service';
import { useStores } from '../../../store';
import { WIDGET_NAME_MAP } from '../../../../utils/widget-map';
import LoadingWrapper from '../../../shared/loading-wrapper/loading-wrapper';
import {RISK_LEVEL_CONFIG} from '../security-dashboard.constant';
import { fillMissingDates, aggregateDataByWeek } from '../../../../utils/parse';
import { DATE_OPTIONS } from '../../../../utils/constants';

const IssueCategories = observer(() => {
    const { dashboardStore, customerStore } = useStores();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [rangeType, setRangeType] = useState<'daily' | 'weekly'>('daily');

    useEffect(() => {
        setIsLoading(true);
        if (customerStore.selectedCustomer) {
            widgetsService.getWidgetData(customerStore.selectedCustomer.name, WIDGET_NAME_MAP.ISSUES_CATEGORIES, dashboardStore.dateRangeObj)
                .then((res) => {
                    let processedData: any[];

                    if (DATE_OPTIONS[dashboardStore.selectedRangeIndex].value > 7) {
                        processedData = aggregateDataByWeek(res, dashboardStore.dateRangeObj);
                        setRangeType('weekly');
                    } else {
                        processedData = fillMissingDates(res, dashboardStore.dateRangeObj);
                        setRangeType('daily');
                    }

                    setData(processedData);
                    setIsLoading(false);
                }).catch(() => setIsLoading(false));
        }
    }, [dashboardStore.dateRangeObj, customerStore.selectedCustomer]);

    return (
        <div className="issue-categories">
            <div className="title">
                <LoadingWrapper isLoading={isLoading} skeletonProps={{ height: 26 }}>
                    {DATE_OPTIONS[dashboardStore.selectedRangeIndex].value == 28 ? 'Weekly Devices at Risk' :'Daily Devices at Risk'}
                </LoadingWrapper>
            </div>
            <LoadingWrapper isLoading={isLoading} skeletonProps={{ height: 250 }}>
                <BarChart data={data} rangeType={rangeType} />
                <div className="legend">
                    {RISK_LEVEL_CONFIG.map((config) => (
                        <div key={config.fieldName} className="legend-item">
                            <div className="legend-color"
                                 style={{
                                     background: `linear-gradient(to left, ${config.color} 0%, rgba(255, 255, 255, 0) 100%)`
                                 }}
                            />
                            <span className="legend-text">{config.fieldName}</span>
                        </div>
                    ))}
                </div>
            </LoadingWrapper>
        </div>
    );
});

export default IssueCategories;
